export default __webpack_public_path__ + "static/media/radio-checked.d621bfee.svg";